import { useTranslation } from "react-i18next";
import SingleSelectFilterModal from "../../../ui/components/filters/SingleSelectFilterModal";

export const getStatusOptions = (t) => [
  { label: t("All"), value: "all" },
  { label: t("Image en traitement"), value: "ImageEnTraitement" },
  { label: t("A compléter"), value: "ACompleter" },
  { label: t("Correction en traitement"), value: "CorrectionEnTraitement" },
  { label: t("Validated"), value: "Validated" },
  { label: t("Error"), value: "Error" },
];

const StatusFilterModal = ({
  isOpen,
  onClose,
  onApply,
  currentStatusFilter,
}) => {
  const { t } = useTranslation();

  return (
    <SingleSelectFilterModal
      isOpen={isOpen}
      onClose={onClose}
      onApply={onApply}
      title={t("Status")}
      options={getStatusOptions(t)}
      currentValue={currentStatusFilter}
      getOptionDataAttribute={(option) => option.value}
    />
  );
};

export default StatusFilterModal;
